import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import Page from "../../index";
import Container from "../container";

// import Main from "./components/Main";
import MainContainer from "./Container";

import { Mixpanel } from "../../../components/shared/Mixpanel";
import * as SearchActions from "../../../redux/actions/search";
import * as ShopifyActions from "../../../redux/actions/shopify";
import * as UserActions from "../../../redux/actions/user";
import sendViewEvent from "./services/sendViewEvent";

import getLatestPublisher from "../../../redux/actions/publisher/handlers/getLatest";
import onClickShareCollection from "../../../redux/actions/merchandising/handlers/onClickShareCollection";
import onClickCollectionCard from "../../../redux/actions/merchandising/handlers/onClickCollectionCard";

function LicensingView(props) {
  const { video } = props.detail;
  let videoUrl = "";
  if (video) {
    videoUrl = `//players.brightcove.net/${process.env.REACT_APP_BRIGHTCOVE_ACCOUNT_ID}/${process.env.REACT_APP_BRIGHTCOVE_PLAYER_ID}_default/index.html?videoId=${video.fields.brightCoveVideoId}`;
  }

  useEffect(() => {
    Mixpanel.track("View Detail Page");
  }, []);

  return (
    <Page
      id="licensingView"
      title={video && video.fields.publishingTitle}
      description={video && video.fields?.publishingDescription?.replace(/(<([^>]+)>)/gi, "")}
      image={video && video.fields.imgUrl}
      video={`http:${videoUrl}`}
      videoSecureUrl={`https:${videoUrl}`}
      videoType="video/mp4"
      contentType="video.other"
      width="304"
      height="540"
    >
      <Container headerSticky={false}>
        <MainContainer {...props} />
        {/* <Main {...props} /> */}
      </Container>
    </Page>
  );
}

LicensingView.propTypes = {
  detail: PropTypes.shape().isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
  auth: state.auth,
  detail: state.detail,
  shopify: state.shopify,
  publisher: state.publisher,
});

const mapDispatchToProps = {
  ...UserActions,
  ...SearchActions,
  ...ShopifyActions,
  sendViewEvent,
  getLatestPublisher,
  onClickShareCollection,
  onClickCollectionCard,
};

export default connect(mapStateToProps, mapDispatchToProps)(LicensingView);
